import { SvgIcon, SvgIconProps } from '@mui/material';

export const NavigationArrowLeftIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="22"
    height="16"
    viewBox="0 0 22 16"
    sx={{ fill: 'none', stroke: 'black' }}
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 8L3 8"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 1L2 8L9 15"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
